/**
 * Whether a sale happened on an earlier calendar day than `now` — beaut-484.
 *
 * This decides whether a cancellation needs to ask which till day it settles
 * on. Sold today, both answers are the same till and the question is noise;
 * sold earlier, settling on today misstates today's drawer.
 *
 * Calendar days in the viewer's timezone, not elapsed hours: a sale at 23:50
 * yesterday is a different till from one at 00:10 today.
 */
export function isEarlierDay(iso: string | undefined, now: Date = new Date()): boolean {
  if (!iso) return false;
  const sale = new Date(iso);
  if (Number.isNaN(sale.getTime())) return false;
  // Strictly before today: a sale dated in the future must not offer a
  // future till to settle on.
  const saleDay = new Date(sale.getFullYear(), sale.getMonth(), sale.getDate());
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return saleDay.getTime() < today.getTime();
}
